import { ENDPOINT } from '~/constants';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import {
  type StartProcessFromFilesRequestParameters,
  type StartProcessFromFilesResponse,
} from './types';

/**
 * Start a new invoice process using the given files and parameters.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice/operation/start_process_from_files_invoice_process_start_from_files_post
 */
export async function startInvoiceProcessFromFiles({
  aiModelId,
  dryRun = true,
  files = [],
  senderAddress,
}: StartProcessFromFilesRequestParameters) {
  try {
    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
    }

    formData.append('dryRun', 'true');
    if (aiModelId) {
      formData.append('aiModelId', aiModelId);
    }

    if (senderAddress) {
      formData.append('senderAddress', senderAddress);
    }

    const response = await vestigasApi
      .post(ENDPOINT.INVOICE_REPROCESSING.START_PROCESS_FROM_FILES(), {
        body: formData,
        // TODO: Implement validation of formData as request body in data/kyClient
        // validate: {
        //   body: zodStartProcessFromFilesRequestParametersSchema,
        // },
      })
      .json<StartProcessFromFilesResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error starting invoice process from files',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(
            ($) => $.startInvoiceProcessFromFiles.error422,
            { ns: 'data' },
          );
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) => $.startInvoiceProcessFromFiles.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
}
